import React from "react";
import { SingleBusinessAddressType } from "types";
import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import Info from "pages/WorkersCompApplcation/formStepComponents/ReviewAndSubmit/components/Info";
interface ISavedAddressProps {
  data?: SingleBusinessAddressType;
}

const SaveAddressList = ({ ...props }: ISavedAddressProps): JSX.Element => {
  const { data } = props;
  if (!data) {
    return (
      <p>
        Please complete or delete the information in this card before moving
        forward.
      </p>
    );
  }
  const questionList = Object.entries(
    sectionsQuestions["officeLocation"].questions
  );

  return (
    <div data-testid="saved-address-list">
      {questionList.map(([key, value]) => {
        return (
          <Info
            key={key}
            questionFieldName={key}
            question={value}
            answer={data[key as keyof SingleBusinessAddressType]}
          />
        );
      })}
    </div>
  );
};

export default SaveAddressList;
